import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Notification } from '../../share/models/notification.model';

@Injectable({
  providedIn: 'root'
})

export class EventService {
  private subject = new Subject<any>();
  private subjectModal = new Subject<any>();

  sendNotificationEvent(notification: Notification) {
    this.subject.next(notification);
  }

  getNotificationEvent(): Observable<any> {
      return this.subject.asObservable();
  }

  sendConsolidationConfirmEvent() { 
    this.subjectModal.next(null);
  }

  getConsolidationConfirmEvent(): Observable<any> { 
    //Restart the event
    this.subjectModal = new Subject<any>();
    return this.subjectModal.asObservable();
  }
}
